import { render, staticRenderFns } from "./ParcelRightPanel.vue?vue&type=template&id=0bdfa7a5"
import script from "./ParcelRightPanel.vue?vue&type=script&lang=js"
export * from "./ParcelRightPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports